import Proxy from "./Proxy"

class CourseContractProxy extends Proxy {
  constructor(parameters = {}) {
    super("course-contracts", parameters)
  }
}

export default CourseContractProxy
